// FT-200: поля пары входа в кабинет клиента (номер бронирования и фамилия).
// Rollbar дописывает этот список к своему (handleOptions: concat с browserDefaults.scrubFields),
// и по нему маскирует значения полей ввода в телеметрии (autoInstrument.dom) и query-параметры
// адресов в навигационной телеметрии — иначе введённая пара доезжает до Rollbar с любым отчётом.
export const ROLLBAR_SCRUB_FIELDS = ["booking_id", "last_name"];
